import { AsyncStorage } from "../native";
import * as R from 'unitx/ramda';
const DEFAULT_VERSION = null;
const DEFAULT_PERSISTED_DATA = {
  value: {},
  version: DEFAULT_VERSION
};
export default (options => {
  const {
    name,
    persist = R.identity,
    version = DEFAULT_VERSION,
    migrations
  } = options !== null && options !== void 0 ? options : {};
  return {
    set: async value => {
      const selectedPart = persist(value);
      await AsyncStorage.setItem(name, JSON.stringify({
        value: selectedPart,
        version
      }));
    },
    get: async () => {
      const resultString = await AsyncStorage.getItem(name);
      const persistedData = resultString ? JSON.parse(resultString) : DEFAULT_PERSISTED_DATA;
      const migratedPersistedData = await migrate(migrations, {
        name,
        persistedData,
        version
      });
      return migratedPersistedData.value;
    },
    purge: async () => {
      await AsyncStorage.removeItem(name);
    }
  };
});
/**
 * to sort migrations
 */

const sortByFirstItem = R.sortBy(R.prop(0));

const migrate = async (migrations = {}, options) => {
  const {
    persistedData,
    version,
    name
  } = options;
  let isChanged = false;
  let currentVersion = persistedData.version; // console.log('M',migrations)

  if (!currentVersion) {
    return {
      value: persistedData.value,
      version
    };
  }

  const data = R.reduce((acc, [migrationVersion, migration]) => {
    // console.log('C',currentVersion, migrationVersion)
    if (currentVersion < migrationVersion && migrationVersion < version) {
      isChanged = true; // console.log('migrated from:', currentVersion, 'to:',migrationVersion)

      currentVersion = migrationVersion;
      return migration(acc);
    }

    if (migrationVersion >= version) {
      return R.reduced(acc);
    }

    return acc;
  }, persistedData.value)(sortByFirstItem(R.toPairs(migrations)));

  if (isChanged) {
    AsyncStorage.setItem(name, JSON.stringify({
      value: data,
      version
    }));
  }

  return {
    value: data,
    version
  };
};